import Swal from "sweetalert2";

const useSwal = () => {

  const confirmDelete = async (title = "Are you sure?", text = "You won't be able to revert this!") => {
    return await Swal.fire({
      title,
      text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    });
  };

  const confirm = async (options = {}) => {
    const defaultOptions = {
      title: "Are you sure?",
      text: "Do you want to proceed?",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "Cancel"
    };

    return await Swal.fire({
      ...defaultOptions,
      ...options
    });
  };

  const success = async (title = "Success!", text = "Operation completed successfully.") => {
    return await Swal.fire({
      title,
      text,
      icon: "success",
      confirmButtonColor: "#3085d6"
    });
  };

  const error = async (title = "Error!", text = "Something went wrong.") => {
    return await Swal.fire({
      title,
      text,
      icon: "error",
      confirmButtonColor: "#d33"
    });
  };

  const input = async (options = {}) => {
    const defaultOptions = {
      title: "Enter information",
      input: "text",
      showCancelButton: true,
      confirmButtonText: "Submit",
      showLoaderOnConfirm: true,
      preConfirm: (value) => {
        if (!value) {
          Swal.showValidationMessage("This field is required");
        }
        return value;
      }
    };

    return await Swal.fire({
      ...defaultOptions,
      ...options
    });
  };

  return {
    confirmDelete,
    confirm,
    success,
    error,
    input
  };
};

export default useSwal;